import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';

export var IntegrationLocks = {
	
	manageLocks() {
		var locksWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Locks',
			icon: 'vaadin:lock',
			width: .75,
			height: .75,
			listeners: {
				ready: function () {
					locksWin.show();

					var lockTools = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [
							{
								tag: 'vaadin-combo-box',
								itemid: 'filterStatus',
								'class': 'spacer-toolbar-item',
								'keep-open': true,
								style: 'width: 250px;',
								label: 'Status',
								'item-value-path': 'code',
								'item-label-path': 'description',
								value: 'A',
								postinit: function (combo) {
									var status = [{
											code: 'A',
											description: 'Active'
										}, {
											code: 'I',
											description: 'Inactive'
										}];
									combo.items = status;
								},
								placeHolder: 'Select',
								listeners: {
									change: function () {
										actionRefreshLocks();
									}
								}
							},
							{
								tag: 'span',
								innerHTML: '|'
							},
							{
								tag: 'dl-action-button',
								itemid: 'add',
								theme: 'primary',
								'class': 'spacer-toolbar-item',
								permissions: ['ADMIN_INTEGRATION_LOCKS:WRITE'],
								children: [
									ElementUtil.makeIcon('vaadin:plus', ' Add')
								],
								listeners: {
									click: function () {
										addLock();
									}
								}
							},
							{
								tag: 'div',
								style: 'float: right;margin-top: 35px;',
								children: [
									{
										tag: 'dl-action-button',
										itemid: 'delete',
										theme: 'error primary',
										permissions: ['ADMIN_INTEGRATION_LOCKS:DELETE'],
										'class': 'spacer-toolbar-item',
										disabled: true,
										children: [
											ElementUtil.makeIcon('vaadin:trash', ' Remove Lock')
										],
										listeners: {
											click: function () {
												removeLock(lockGrid.selectedItems[0]);
											}
										}
									}
								]
							}
						]
					});

					var lockGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true
						},
						children: [
							{
								tag: 'vaadin-grid-column',
								'flex-grow': '0',
								width: '50px',
								renderer: function (root, column, rowData) {
									var expander = ElementUtil.create({
										tag: 'span',
										trustedInnerHTML: true,
										innerHTML: '<b>+</b>',
										properties: {
											expanded: false
										},
										listeners: {
											click: function () {
												if (expander.expanded) {
													expander.innerHTML = '<b>+</b>';
													expander.expanded = false;
													lockGrid.closeItemDetails(root.item);
												} else {
													expander.innerHTML = '<b>-</b>';
													expander.expanded = true;
													lockGrid.openItemDetails(root.item);
												}
											}
										}
									});
									root.item = rowData.item;
									if (!root.firstElementChild) {
										root.append(expander);
									}
								}
							},
							{
								path: 'lockSource',
								header: 'Lock source',
								width: '8em'
							},
							{
								path: 'moduleDescription',
								header: 'Module',
								width: '7em'
							},
							{
								path: 'transmissionDescription',
								header: 'Transmission',
								width: '7em'
							},
							{
								path: 'note',
								header: 'Note',
								width: '7em'
							},
							{
								path: 'updateDts',
								header: 'Update Date',
								width: '7em',
								renderer: function (root, column, rowData) {
									root.innerHTML = TimeUtil.formatDateStandard(rowData.item.updateDts);
								}
							},
							{
								path: 'updateUser',
								header: 'Update User',
								width: '7em'
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								lockGrid.selectedItems = item ? [item] : [];

								if (lockGrid.selectedItems.length > 0) {
									if (lockGrid.selectedItems[0].activeStatus === 'A') {
										ElementUtil.query(lockTools, 'delete').disabled = false;
									} else {
										ElementUtil.query(lockTools, 'delete').disabled = true;
									}
								} else {
									ElementUtil.query(lockTools, 'delete').disabled = true;
								}
							}
						}
					});

					lockGrid.rowDetailsRenderer = function (root, grid, rowData) {
						if (root.firstElementChild) {
							return;
						}
						var lock = rowData.item;
						var panel = document.createElement('div');
						panel.style.border = '1px solid var(--lumo-contrast-20pct, #ccc)';
						panel.style.padding = '8px';

						function appendDetailRow(label, text) {
							if (text === null || text === undefined || text === '') {
								return;
							}
							var row = document.createElement('div');
							row.style.marginBottom = '4px';
							var labelNode = document.createElement('strong');
							labelNode.textContent = label + ': ';
							row.appendChild(labelNode);
							row.appendChild(document.createTextNode(String(text)));
							panel.appendChild(row);
						}

						function appendDetailDateRow(label, dateValue) {
							if (!dateValue) {
								return;
							}
							appendDetailRow(label, TimeUtil.formatDateStandard(dateValue));
						}

						appendDetailRow('Lock ID', lock.lockId);
						appendDetailRow('Application module (code)', lock.applicationModule);
						appendDetailRow('Transmission type (code)', lock.transmissionType);
						appendDetailRow('Active status', lock.activeStatus);
						appendDetailRow('Create user', lock.createUser);
						appendDetailDateRow('Create date', lock.createDts);
						appendDetailRow('System update ID', lock.systemUpdateId);
						appendDetailRow('Outage pattern', lock.outagePattern);
						appendDetailRow('Recovery state', lock.recoveryState);
						appendDetailDateRow('Last canary', lock.lastCanaryDts);
						appendDetailRow('Canary config ID', lock.canaryConfigId);
						appendDetailDateRow('Healing started', lock.healingStartedDts);
						appendDetailDateRow('Detected outage', lock.detectedOutageDts);
						root.appendChild(panel);
					};

					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [
							lockTools,
							lockGrid
						]
					});

					locksWin.addToContentElement(layout);

					var actionRefreshLocks = function () {
						var loadMask = lockGrid.showLoading();
						var paging = {
							status: ElementUtil.query(lockTools, 'filterStatus').value
						};
						DataManagementService.getIntegrationService().getIntegrationLocks(paging).then(function (locks) {
							loadMask.remove();
							lockGrid.activeItem = null;
							lockGrid.items = locks.data;
						});
					};
					actionRefreshLocks();

					var addLock = function () {
						var addLockWin = ElementUtil.create({
							tag: 'dl-dialog',
							title: 'Add Lock',
							icon: 'vaadin:plus',
							width: 500,
							height: 325,
							listeners: {
								ready: function () {
									addLockWin.show();


									var formPanel = ElementUtil.create({
										tag: 'dl-form-panel',
										itemid: 'form',
										children: [
											{
												tag: 'vaadin-form-layout',
												children: [
													{
														tag: 'vaadin-combo-box',
														label: 'Module',
														name: 'applicationModule',
														'item-value-path': 'code',
														'item-label-path': 'description',
														required: true,
														postinit: function (combo) {
															DataManagementService.getIntegrationService().getAvailableModules().then(function (data) {
																combo.items = data;
																if (data && data.length > 0) {
																	combo.value = data[0].code;
																}
															});
														}
													},
													{
														tag: 'vaadin-combo-box',
														label: 'Transmission Type',
														name: 'transmissionType',
														'item-value-path': 'transmissionType',
														'item-label-path': 'transmissionDescription',
														placeHolder: 'All',
														postinit: function (combo) {
															DataManagementService.getIntegrationService().getDefinitions().then(function (data) {
																combo.items = data;
															});
														}
													},
													{
														tag: 'vaadin-text-field',
														label: 'Note',
														name: 'note',
														maxlength: 255
													},
													{
														tag: 'hr',
														colspan: 2
													},
													{
														tag: 'div',
														style: 'text-align: center;',
														colspan: 2,
														defaults: {
															tag: 'vaadin-button'
														},
														children: [
															{
																theme: 'primary',
																children: [
																	ElementUtil.makeIcon('vaadin:database', ' Save')
																],
																listeners: {
																	click: function () {

																		formPanel.submitForm({
																			preSubmit: function (data) {
																				return data;
																			},
																			actualCall: function (data) {
																				return DataManagementService.getIntegrationService().saveIntegrationLock(data, false);
																			},
																			success: function (data, responseData) {
																				window.DL.MessageUtil.showToast('Success', 'Saved Lock', {
																					theme: 'success',
																					position: 'top-stretch'
																				});
																				if (formPanel.successCallback) {
																					formPanel.successCallback();
																				}
																				actionRefreshLocks();
																				addLockWin.close();
																			}
																		});

																	}
																}
															},
															{
																theme: 'tertiary',
																innerHTML: 'Cancel',
																style: 'margin-left: 10px;',
																listeners: {
																	click: function () {
																		//cancel
																		addLockWin.close();
																	}
																}
															}
														]
													}
												]
											}
										]

									});
									addLockWin.addToContentElement(formPanel);

								}
							}
						});
					};

					var removeLock = function (lock) {
						window.DL.MessageUtil.showConfirm({
							title: 'Confirm Remove',
							message: 'Are you sure you want to remove lock?',
							buttons: [
								{
									text: 'Yes',
									handler: function () {
										var loadMask = lockGrid.showLoading('Removing lock...');

										DataManagementService.getIntegrationService().deleteIntegrationLock(lock.lockId)
												.then(function () {
													loadMask.remove();
													window.DL.MessageUtil.showToast('Success', 'Removed Lock', {
														theme: 'success'
													});
													actionRefreshLocks();
												});
									}
								},
								{
									text: 'No'
								}
							]
						});
					};
				}
			}
		});
	}
	
};


